var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n   .left-arrow-icon{\n    fill:none;\n    stroke-linejoin:round;\n  }\n  .left-arrow-icon .b{\n    stroke:#4A4A4A;\n  }\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "left-arrow-icon"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("polyline", {
    transform: "translate(-30 -97)translate(35 105)rotate(-180)translate(-35 -105)",
    points: "31 97 39 105 31 113",
    className: "undefined"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowLeft);
export default __webpack_public_path__ + "static/media/icArrowLeft.0c5ab60259d45122a6c595977179caa1.svg";
export { ForwardRef as ReactComponent };